import { HueLogoTile } from '@hue/design-system';
import type { BrandLogoSet } from '../lib/api.js';
import { useColorMode, useLogoUrl } from './brand.js';

/// A marca do produto no alto do menu, a mesma do portal (ADR 0040, adendo de 17/10/2026). Fixa:
/// não é configurável pela empresa. Recolhido, só o símbolo.
export function HueSystemMark({ collapsed = false }: { collapsed?: boolean }) {
  const tile = <HueLogoTile className="size-9 rounded-xl" />;
  if (collapsed) {
    return (
      <span role="img" aria-label="HUE•System">
        {tile}
      </span>
    );
  }
  return (
    <span className="flex min-w-0 items-center gap-3">
      {tile}
      <strong className="text-base font-bold tracking-[-.03em]">
        HUE<span className="text-brand-400">•</span>System
      </strong>
    </span>
  );
}

/// A identidade da empresa no centro do topo. A logo principal (no escuro, a própria para fundo
/// escuro, ou a principal sobre uma faixa clara); sem logo principal, o símbolo e o nome; sem
/// nada, o nome.
export function CompanyIdentityMark({ name, logos }: { name: string; logos: BrandLogoSet }) {
  const mode = useColorMode();
  const symbolUrl = useLogoUrl(logos.SYMBOL);
  const wide = mode === 'dark' && logos.DARK ? logos.DARK : logos.MAIN;
  const wideUrl = useLogoUrl(wide);
  const onBand = mode === 'dark' && wide === logos.MAIN;

  if (wideUrl) {
    return (
      <span
        className={`flex h-10 min-w-0 items-center ${onBand ? 'rounded-lg bg-white px-2 py-1' : ''}`}
      >
        <img src={wideUrl} alt={name} className="max-h-8 max-w-[180px] object-contain" />
      </span>
    );
  }

  return (
    <span className="flex min-w-0 items-center gap-2.5">
      {symbolUrl ? (
        <img src={symbolUrl} alt="" className="size-8 shrink-0 rounded-lg object-contain" />
      ) : null}
      <strong className="truncate text-base font-bold tracking-[-.03em]">{name}</strong>
    </span>
  );
}
